import { action, atom } from "@reatom/core"

import { SessionTimeInterval } from "utils/interfaces"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { createList } from "modules/PsyCatalog/common/models/utils"

export function sessionTimeIntervalsField() {
    const inputValue = atom<SessionTimeInterval[]>([])
    const update = action((ctx, value: SessionTimeInterval) => {
        inputValue(ctx, (values) => {
            const { toggle } = createList(values)
            return toggle(value)
        })
    })

    function onChange(value: SessionTimeInterval) {
        update(ctx, value)
    }

    return { inputValue, onChange, update }
}
